import { ReactElement, FC, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  CardMedia,
  Container,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Props from "./home.interface";
import { Carousel, CardLeftPhoto, Helper, ButtonPrimary } from "@components";
import person from "../../assets/person.png";
import flags from "../../assets/flags.png";
import phones from "../../assets/phones.png";

import sludge from "../../assets/sludge.png";
import education from "../../assets/education.png";
import community from "../../assets/community.png";
import volunteer from "../../assets/volunteer.png";
import surveyIcon from "../../assets/surveyIcons.png";
import questionIcon from "../../assets/questionIcon.png";
import locationIcon from "../../assets/locationIcon.png";
import { useMediaQuery } from "@mui/material";
// import { HomeLayoutRoot } from "./home.styled";
import "./home.css";
import ExploreSection from "./../../components/ExploreSection/Explore";
import {
  CardData,
  NewsCard,
  NewsCardsContainer,
  NewsLeftCardContainer,
} from "./home.styled";
import General from "../../stores/GeneralStore";
const Home: FC<Props> = (): ReactElement => {
  const [selectValue, setSelectValue] = useState<number>(1);
  const handleChange = (e?: any): void => {
    setSelectValue(e.target.value);
  };
  const mobile = useMediaQuery("(max-width: 768px)");
  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        backgroundColor: "primary.light",
      }}
    >
      <Container maxWidth={false} disableGutters sx={{ background: "#eee" }}>
        <Box
          sx={{
            flexGrow: 1,
            backgroundColor: "whitesmoke",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingX: 0,
          }}
        >
          <Carousel />
        </Box>
        <Grid
          width={"100%"}
          alignItems={"center"}
          sx={{
            background: "#eee",
            display: "flex",
            paddingBottom: "3rem",
            flexDirection: "column",
            gap: "1rem",
            "@media(min-width: 768px)": { width: "80%", margin: "auto" },
          }}
        >
          <ExploreSection />
        </Grid>
        {/* We’re Here to Help */}

        <Grid
          container
          sx={{
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "center",
            gap: "2em",
            alignItems: "center",
            padding: "100px",
          }}
        >
          <Grid
            item
            sm={12}
            xs={12}
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingX: 0,
            }}
          >
            <Typography
              sx={{
                color: "#101E8E",
                fontFamily: "Segoe UI",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "50px",
              }}
            >
              We’re Here to Help

            </Typography>
          </Grid>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1em",
              justifyContent: "space-between",
              "@media(max-width: 780px)": {
                flexDirection: "column",
              },
            }}
          >
            <Grid item sm={2} xs={12}>
              <Helper
                iconSrc={locationIcon}
                text="Have questions? Read our FAQs and get answers to your questions."
                title="FAQ"
              />
            </Grid>
            <Grid item sm={2} xs={12}>
              <Helper
                iconSrc={questionIcon}
                text="Find the nearest customer service center and its location."
                title="Locations"
              />
            </Grid>
            <Grid item sm={2} xs={12}>
              <Helper
                iconSrc={surveyIcon}
                text="Participate in our survey and give us your valulable insights "
                title="Surveys"
              />
            </Grid>
            <span className="marginer"></span>
            <Grid
              item
              sm={4}
              xs={10}
              display="flex"
              flexDirection="column"
              sx={{
                gap: "3rem",
                maxWidth: "30%",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  alignItems: "between",
                }}
                display={"flex"}
                flexDirection={"row"}
              >
                <Typography
                  mb={"auto"}
                  sx={{
                    fontFamily: "Segoe UI",
                    fontWeight: 700,
                    fontSize: "18px",
                    lineHeight: "25px",
                    color: "#101E8E",
                  }}
                >
                  Share Feedback or Suggestions
                </Typography>
              </Box>
              <Box
                sx={{
                  alignItems: "between",
                  gap: "1rem",
                }}
                display={"flex"}
                flexDirection={"row"}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Age</InputLabel>
                  <Select
                    sx={{
                      backgroundColor: "whitesmoke",
                      color: "#101e8e",
                      "&:hover": {
                        border: "1px solid #fff",
                      },
                    }}
                    onChange={handleChange}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectValue}
                    label="Age"
                  >
                    <MenuItem value={1} disabled>
                      I want to give a suggestion
                    </MenuItem>
                    <MenuItem value={10}>Ten</MenuItem>
                    <MenuItem value={20}>Twenty</MenuItem>
                    <MenuItem value={30}>Thirty</MenuItem>
                  </Select>
                </FormControl>
                <ButtonPrimary label="NEXT" />
              </Box>
            </Grid>
          </Box>
          {/* <Grid item sm={2} xs={12}>
            
          </Grid> */}
        </Grid>

        {/* <CardWrapper>
          <Card className="card-wrapper">
            <CardActionArea className="card-action-area">
              <CardMedia
                component="img"
                className="left-card-media"
                image={sludge}
                alt="green iguana"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  Lizard
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Lizards are a widespread group of squamate reptiles, with over
                  6,000 species, ranging across all continents except Antarctica
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
          <div className="right-section-card-wrapper">
            <Card className="right-card-wrapper">
              <CardActionArea className="right-card-action-area">
                <CardMedia
                  component="img"
                  className="card-media"
                  image={education}
                  alt="green iguana"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Lizard
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Lizards are a widespread group of squamate reptiles, with
                    over 6,000 species, ranging across all continents except
                    Antarctica
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
            <Card className="right-card-wrapper">
              <CardActionArea className="right-card-action-area">
                <CardMedia
                  component="img"
                  className="card-media"
                  image={volunteer}
                  alt="green iguana"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Lizard
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Lizards are a widespread group of squamate reptiles, with
                    over 6,000 species, ranging across all continents except
                    Antarctica
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
            <Card className="right-card-wrapper">
              <CardActionArea className="right-card-action-area">
                <CardMedia
                  component="img"
                  className="card-media"
                  image={community}
                  alt="green iguana"
                />
                <CardContent>
                  <Typography gutterBottom variant="h5" component="div">
                    Lizard
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Lizards are a widespread group of squamate reptiles, with
                    over 6,000 species, ranging across all continents except
                    Antarctica
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>
        </CardWrapper> */}

        {/* Our Impact */}

        <Grid
          container
          spacing={2}
          sx={{
            backgroundColor: "#62AA51",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "100px",
          }}
        >
          <Grid
            item
            sm={12}
            xs={12}
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingX: 0,
            }}
          >
            <Typography
              sx={{
                color: "#FFFFFF",
                fontFamily: "Segoe UI",
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "50px",
              }}
            >
              Our Impact
            </Typography>
          </Grid>
          <Grid item sm={6} xs={12} sx={{ height: "100%" }}>
            <Card sx={{ borderRadius: "0" }}>
              <CardMedia
                sx={{ minHeight: 320 }}
                image={sludge}
                title="green iguana"
              />
              <CardContent
                style={{
                  backgroundColor: "#101E8E",
                  color: "#FFF",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  height: "195px",
                }}
              >
                <Typography
                  variant="h5"
                  component="div"
                  sx={{ alignSelf: "flex-start", fontWeight: "600" }}
                >
                  Region’s First Sludge to Energy Initiative
                </Typography>
                <Typography variant="body2" height="120">
                  Arguably one of our most high-impact projects, the sludge to
                  energy initiative is the culmination of our vision to
                  transform Ajman, and by extension, catapult UAE’s objective to
                  become an energy efficient nation sooner rather than later.
                  <br />
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid
            item
            sm={6}
            xs={12}
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              gap: "1rem",
            }}
          >
            <CardLeftPhoto
              text="Ajman Sewerage Community Care Foundation"
              imageSrc={community}
            />
            <CardLeftPhoto
              text="Educational Tours for Schools and Students"
              imageSrc={education}
            />
            <CardLeftPhoto
              text="Volunteering and Bird-Watching Activities"
              imageSrc={volunteer}
            />
          </Grid>
        </Grid>
        <Grid
          item
          sm={6}
          xs={12}
          sx={{
            display: "grid",
            placeItems: "center",
            background: "#eee",
            margin: "auto",
            width: "90%",
          }}
        >
          <Grid>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                gap: "3rem",
                width: "95%",
                margin: "3rem auto 3rem auto",
              }}
            >
              <Typography
                sx={{
                  color: "#101e8e",
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: 700,
                  fontSize: "50px",
                }}
              >
                News & Events
              </Typography>
              <Grid sx={{ width: "90%" }}>
                <NewsCardsContainer>
                  <NewsLeftCardContainer>
                    <NewsCard
                      flexDirection={!mobile ? "row" : "column"}
                      style={{
                        width: "95%",
                        gap: "0",
                      }}
                    >
                      <img
                        src={person}
                        alt=""
                        style={{ height: "100%", width: "40%" }}
                      />
                      <CardData style={{ height: "100%", width: "60%" }}>
                        <span>17 Sep 2021</span>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: "bold",
                            justifySelf: "flex-start",
                            paddingTop: "0.9rem",
                          }}
                        >
                          Ajman Pioneers Sludge-to-Energy Plant
                        </Typography>
                        <section>
                          <span style={{ color: "#62aa51" }}>
                            Read More <ArrowForwardIcon />
                          </span>{" "}
                          <button disabled style={{ border: "none" }}>
                          {General?.codeLabels["cm_mob_news"]?.label !== undefined ? General?.codeLabels["cm_mob_news"]?.label : "News"}
                          </button>
                        </section>
                      </CardData>
                    </NewsCard>
                    <NewsCard
                      style={{
                        gap: "0",
                        width: "95%",
                      }}
                      flexDirection={mobile ? "column" : "row"}
                    >
                      <img
                        src={flags}
                        alt=""
                        style={{ height: "100%", width: "40%" }}
                      />
                      <CardData style={{ height: "100%", width: "60%" }}>
                        <span>17 Sep 2021</span>
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: "bold",
                            justifySelf: "flex-start",
                            paddingTop: "0.9rem",
                          }}
                        >
                          Ajman Sewerage Welcomes the Year of Tolerance
                        </Typography>
                        <section>
                          <span style={{ color: "#62aa51" }}>
                            Read More <ArrowForwardIcon />
                          </span>{" "}
                          <button disabled style={{ border: "none" }}>
                          {General?.codeLabels["cm_blogs"]?.label !== undefined ? General?.codeLabels["cm_blogs"]?.label : "Blogs"}

                          </button>
                        </section>
                      </CardData>
                    </NewsCard>
                  </NewsLeftCardContainer>
                  <NewsCard
                    style={{
                      height: "541px",
                      width: "40%",
                    }}
                    flexDirection="column"
                  >
                    <div style={{ height: "40%", width: "100%" }}>
                      <img
                        src={phones}
                        alt=""
                        style={{ width: "100%", height: "220px" }}
                      />
                    </div>
                    <CardData style={{ height: "70%", width: "100%" }}>
                      <span>17 Sep 2021</span>
                      <Typography
                        variant="h5"
                        sx={{
                          fontWeight: "bold",
                          alignSelf: "flex-start",
                          paddingTop: "1.2rem",
                        }}
                      >
                        Join us at GITEX and get a chance to win new Samsung
                        Galaxy Phone
                      </Typography>
                      <section>
                        <span style={{ color: "#62aa51" }}>
                          Read More <ArrowForwardIcon />
                        </span>{" "}
                        <button disabled style={{ border: "none" }}>
                        {General?.codeLabels["cm_mob_events"]?.label !== undefined ? General?.codeLabels["cm_mob_events"]?.label : "Events"}
                        </button>
                      </section>
                    </CardData>
                  </NewsCard>
                </NewsCardsContainer>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Home;
